<div class="card search-speech-container">
  <form class="form-inline">
    <label class="sr-only" for="inlineFormInputName2">Name</label>
    <input
      type="text"
      class="form-control mb-2 mr-sm-2"
      id="inlineFormInputName2"
      placeholder="Enter search text"
      (keyup)="onChange($event)"
    />

    <label class="sr-only" for="inlineFormInputGroupUsername2">Username</label>
    <div class="input-group mb-2 mr-sm-2">
      <select class="form-control" [(ngModel)]="searchKey" name="searchKey">
        <option value="title">Search by Title</option>
        <option value="keywords">Search by Keywords</option>
        <option value="author">Search by Author</option>
      </select>
    </div>
  </form>

  <hr />
  <div class="search-table">
    <table class="table table-striped">
      <thead class="thead-dark">
        <tr>
          <th scope="col">Title</th>
          <th scope="col">Keywords</th>
          <th scope="col">Date Created</th>
          <th scope="col">Author</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let speech of inputSearchKey ? searchItems : speeches$">
          <td>{{ speech.title }}</td>
          <td>
            <div *ngIf="!speech.keywords">N/A</div>
            <div *ngIf="speech.keywords">
              <span
                class="badge badge-pill badge-info"
                *ngFor="let i of speech?.keywords?.split(',')"
                style="margin-right: 4px"
                >{{ i }}</span
              >
            </div>
          </td>
          <td>{{ speech.date }}</td>
          <td>{{ speech.author }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
